import styles from './styles.module.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';

type NavTabsProps<T extends string> = {
  tabs: readonly T[];
  currentTab: T;
  onTabClick: (tab: T) => void;
  rightContent?: ReactNode;
  className?: string;
  isLoading?: boolean;
};

export const NavTabs = <T extends string>({
  tabs,
  currentTab,
  onTabClick,
  rightContent,
  className,
  isLoading = false
}: NavTabsProps<T>) => {
  return (
    <div className={cn('d-flex align-items-center justify-content-between', className)}>
      <ul
        className={`${styles.tabContainer} nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent flex-nowrap`}
      >
        {isLoading
          ? tabs.map((tab) => (
              <li key={tab} className="nav-item">
                <div className="nav-link mx-0 px-0 bg-transparent border-0">
                  <Skeleton width={tab.length * 9} height={24} style={{ borderRadius: 4 }} />
                </div>
              </li>
            ))
          : tabs.map((tab) => (
              <li key={tab} className="nav-item">
                <button
                  className={cn('nav-link text-active-secondary mx-0', {
                    active: currentTab === tab,
                    [styles.inactiveButton]: currentTab !== tab
                  })}
                  onClick={() => onTabClick(tab)}
                  aria-current={currentTab === tab ? 'page' : undefined}
                >
                  <div>{tab}</div>
                </button>
              </li>
            ))}
      </ul>
      {rightContent && <div className="d-flex align-items-center gap-4">{rightContent}</div>}
    </div>
  );
};
